import { render, staticRenderFns } from "./TransportLayout.vue?vue&type=template&id=40157668&scoped=true&"
import script from "./TransportLayout.vue?vue&type=script&lang=js&"
export * from "./TransportLayout.vue?vue&type=script&lang=js&"
import style0 from "./TransportLayout.vue?vue&type=style&index=0&id=40157668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40157668",
  null
  
)

component.options.__file = "TransportLayout.vue"
export default component.exports